var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlickfangIconBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m27.5,55c-15.16,0 -27.5,-12.34 -27.5,-27.5c0,-15.16 12.34,-27.5 27.5,-27.5c15.16,0 27.5,12.34 27.5,27.5c0,15.16 -12.34,27.5 -27.5,27.5zm0,-52.3c-13.67,0 -24.8,11.12 -24.8,24.8s11.13,24.8 24.8,24.8s24.8,-11.13 24.8,-24.8s-11.12,-24.8 -24.8,-24.8z"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "svg_11",
    height: 1.91667,
    width: 23.77919,
    y: 26.54167,
    x: 15.61041,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_12",
    height: 1.91667,
    width: 23.77919,
    y: 15.54141,
    x: 15.61041,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_13",
    height: 1.91667,
    width: 23.77919,
    y: 37.50389,
    x: 15.61041,
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlickfangIconBurger);
export default __webpack_public_path__ + "static/media/Blickfang_Icon-burger.41d6651e5a11c7f6d172cace8289ce75.svg";
export { ForwardRef as ReactComponent };